import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'csl-services-list-skeleton',
  standalone: true,
  imports: [SkeletonComponent],
  templateUrl: './services-list-skeleton.component.html',
  styleUrl: './services-list-skeleton.component.css',
  host: {
    class: 'flex flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesListSkeletonComponent {}
